/* eslint-disable max-len */
/* global window, localStorage, sessionStorage, document */
import { welfareAPIUrl } from "Constants/defaultValues"
import uniqid from "uniqid"
import api from "Util/api"

export const getCompanyId = () => {
  const path = window.location.pathname
  let companyId = path.split("/")[1]
  if (companyId === "iframe") {
    companyId = path.split("/")[2]
  }
  if (companyId === "support") {
    companyId = path.split("/")[3]
  }
  if (
    !companyId ||
    companyId === "iframe" ||
    companyId === "privacy" ||
    companyId === "cookies" ||
    companyId === "reset" ||
    companyId === "accessibility"
  ) {
    // Should pull down all of the client configuration info
    var host = window.location.host
    var subdomain = host.split(".")[0]
    // catch if the url contains www
    if (subdomain === "www") subdomain = host.split(".")[1]
    if (
      host.includes("localhost") ||
      host.includes("192.168.0") ||
      subdomain === "calculator" ||
      subdomain === "benefits" ||
      subdomain === "sitbenefits" ||
      subdomain === "benefitsdev" ||
      subdomain === "benefitsplatform" ||
      subdomain === "sitbenefitsplatform" ||
      subdomain === "devbenefitsplatform"
    ) {
      subdomain = "inbest"
    } else if (subdomain === "adssit" || subdomain === "adsbenefits") {
      subdomain = "ads"
    } else if (subdomain === "street-uk") {
      subdomain = "streetuk"
    } else if (subdomain === "ccu") {
      subdomain = "capitalcreditunion"
    }
    companyId = subdomain
  }
  return companyId
}

export const setCompanyCustomization = async (partnerAppId) => {
  const getCustomizationURL = (appId) => {
    const partnerName = appId ? appId.toLowerCase() : ""
    return `${welfareAPIUrl}/utils/customisation/${partnerName}`
  }

  const getSubpartnerFromURL = () => {
    return new URLSearchParams(window.location.search).get("subpartner")
  }

  const setFavicon = (faviconUrl) => {
    if (faviconUrl) {
      const favicon = document.getElementById("favicon")
      favicon.href = faviconUrl
    }
  }

  const setStyle = (config) => {
    const style = document.createElement("style")
    document.head.appendChild(style)
    style.textContent = `
            .colorpallet { 
                --main-color:${config.colorMain};
                --main-color-dark:${config.colorMainDark};
                --button-text-color:${config.buttonTextColor};
            }
            .custom-radio .custom-control-input:checked ~ .custom-control-label::after { 
                background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='${config.buttonTextColor}'/%3E%3C/svg%3E");
            }
            .custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
                background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='${config.buttonTextColor}' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E");
            }
        `
  }

  try {
    let params = {}
    const subpartner = getSubpartnerFromURL()
    if (subpartner) {
      params.subpartner = subpartner.toLowerCase()
    }

    const response = await api.get(getCustomizationURL(partnerAppId), {
      params
    })
    const config = response.data

    setFavicon(config.faviconUrl)
    setStyle(config)

    return config
  } catch (err) {
    await api.post(`${welfareAPIUrl}/utils/whitelabelLogging`, {
      message: `Whitelabeling failed for customer on ${
        window.location.href
      } | ${err.toString()}`,
      severity: "warning"
    })
    return null
  }
}

export const getOptions = async (companyDetails, isIframe) => {
  const urlSearchParams = new URLSearchParams(window.location.search)
  // Authentication
  let token = urlSearchParams.get("token")
  let expires = urlSearchParams.get("expires")
  // Custom options
  let redirectUrl = urlSearchParams.get("redirectUrl")
  let redirectParent = urlSearchParams.get("redirectParent") === "true"
  let emitLinkEvent = urlSearchParams.get("emitLinkEvent") === "true"
  let onErrorRedirect = urlSearchParams.get("onErrorRedirect")
  let short = urlSearchParams.get("short") === "false" ? false : true
  let edit = urlSearchParams.get("edit") === "true"
  let multiLang = urlSearchParams.get("multiLang") === "true"
  let skipLanding = urlSearchParams.get("skipLanding") === "true"
  let landing = urlSearchParams.get("landing")
  let consentGranted = urlSearchParams.get("consentGranted") === "true"
  // Company detail custom options
  let hideDownloadPdf = companyDetails.hideDownloadPdf
  let openLinksInternally = companyDetails.openLinksInternally
  let lightningEnabled = companyDetails.lightningEnabled
  let hideEmail = companyDetails.hideEmail

  let customId = urlSearchParams.get("customId")
  let subpartner = urlSearchParams.get("subpartner")
  let matomoSiteId = companyDetails.matomoSiteId
  return {
    token,
    expires,
    redirectUrl,
    redirectParent,
    emitLinkEvent,
    onErrorRedirect,
    short,
    edit,
    skipLanding,
    landing,
    customId,
    subpartner,
    matomoSiteId,
    hideDownloadPdf,
    hideEmail,
    openLinksInternally,
    lightningEnabled,
    iframe: isIframe,
    multiLang,
    consentGranted
  }
}

export const getClientAndReferenceNumber = function () {
  const inbestUserIdPrefix = "uid-"
  const urlSearchParams = new URLSearchParams(window.location.search)
  let reference_number =
    urlSearchParams.get("reference_number") ||
    urlSearchParams.get("referenceNumber")
  let user_id = urlSearchParams.get("user_id") || urlSearchParams.get("userId")
  let storedReferenceNumber
  let storedUserId
  try {
    storedReferenceNumber = localStorage.getItem("referenceNumber")
    storedUserId = localStorage.getItem("userId")
  } catch (err) {
    console.log("Unable to access localStorage")
  }
  let referenceNumber = null
  let userId = null

  if (reference_number) {
    referenceNumber = reference_number
  } else if (user_id) {
    referenceNumber = user_id
  } else if (storedReferenceNumber) {
    referenceNumber = storedReferenceNumber
  }

  // If any of the identifiers above start with inbest prefix - it's not a reference number, but a userId
  if (referenceNumber && referenceNumber.startsWith(inbestUserIdPrefix)) {
    // This is inbest userId rather than client's reference number
    userId = referenceNumber
    referenceNumber = null
  } else if (storedUserId) {
    userId = storedUserId
  }
  return { referenceNumber: referenceNumber, userId: userId }
}

export const getWelfareBrowserIdentifiers = function (
  referenceNumber,
  companyId,
  subpartner
) {
  return new Promise((resolve) => {
    const url = welfareAPIUrl + "/utils/generateIdentifiers"
    const params = { referenceNumber, companyId, subpartner }
    api
      .get(url, { params })
      .then((result) => {
        let response = result.data
        let sessionIdentifier = response.sessionIdentifier
        let userIdentifier = response.userIdentifier
        resolve({ sessionId: sessionIdentifier, userId: userIdentifier })
      })
      .catch((err) => {
        console.log("ERROR generating identifiers", err)
        // Generate the identifiers within the browser as a fallback
        let sessionIdentifier = uniqid("sid-")
        let userIdentifier = uniqid("uid-")
        api.post(welfareAPIUrl + "/utils/whitelabelLogging", {
          message: `Failed to get welfare user identifiers ${err.toString()}`,
          severity: "warning"
        })
        resolve({ sessionId: sessionIdentifier, userId: userIdentifier })
      })
  })
}

export const getUserId = async (companyId) => {
  let subpartner = new URLSearchParams(window.location.search).get(
    "subpartner"
  )
  let { referenceNumber, userId } = getClientAndReferenceNumber()
  let identifiers = await getWelfareBrowserIdentifiers(
    referenceNumber,
    companyId,
    subpartner
  )
  let sessionId = identifiers.sessionId
  let userIdentifier = userId ? userId : identifiers.userId
  if (referenceNumber) {
    // If the referenceNumber was provided - take the userIdentifier returned by the API
    userIdentifier = identifiers.userId
  }
  return {
    referenceNumber: referenceNumber,
    userId: userIdentifier,
    sessionId: sessionId
  }
}

export const storeUserIdentifiers = (
  userId,
  referenceNumber,
  sessionId,
  subpartner,
  customId,
  matomoTracker
) => {
  // Set matomo custom dimensions
  try {
    if (matomoTracker && matomoTracker.getSiteId()) {
      matomoTracker.setUserId(userId)
      matomoTracker.setCustomDimension(1, sessionId)
      matomoTracker.setCustomDimension(2, userId)
      if (subpartner) {
        matomoTracker.setCustomDimension(3, subpartner.toLowerCase())
      }
      if (referenceNumber) {
        matomoTracker.setCustomDimension(4, referenceNumber)
      }
      if (customId) {
        matomoTracker.setCustomDimension(5, customId)
      }
    } else {
      console.log("Matomo tracker not initialized")
    }
  } catch (err) {
    console.log("Matomo error", err)
  }

  if (window.gtag) {
    try {
      window.gtag("set", { user_id: userId })
      window.gtag("set", "user_properties", {
        referenceNumber: referenceNumber
      })
    } catch (err) {
      console.error("GA error", err.toString())
    }
  }
  // Try setting the localStorage and localSession variables
  try {
    localStorage.setItem("userId", userId)
    let storedSessionIdentifier = sessionStorage.getItem(
      "userSessionIdentifier"
    )
    if (!storedSessionIdentifier) {
      sessionStorage.setItem("userSessionIdentifier", sessionId)
    }
    if (referenceNumber) {
      localStorage.setItem("referenceNumber", referenceNumber)
    }
  } catch (err) {
    console.log("Local storage is disabled")
  }
}

export const setLanguage = (i18n) => {
  return new Promise((resolve) => {
    let localStorageLanguage = false
    try {
      localStorageLanguage = localStorage.getItem("language")
    } catch (err) {
      localStorageLanguage = false
    }
    let language = new URLSearchParams(window.location.search).get("lang")
    if (language) {
      i18n.changeLanguage(language).then(() => {
        try {
          localStorage.setItem("language", language)
        } catch (err) {
          console.log("Failed to set language in local storage", err)
        }
        resolve()
      })
    } else if (localStorageLanguage) {
      try {
        i18n.changeLanguage(localStorageLanguage).then(() => {
          resolve()
        })
      } catch (err) {
        console.log("Failed to get language in local storage", err)
        resolve()
      }
    } else {
      resolve()
    }
  })
}
